import { ERole, type ChatMessage, type ChatSession, type ConversationSessionItem, type MessageStatus } from '@/types/chat';
import { mindMentionDisplayText } from '@/utils/mindHost';

/** agent 历史 turn.answer = done 事件整包；正文只取 reportText / reportJson.message */
interface AgentTurnAnswer {
  reportText?: string;
  reportJson?: { message?: string };
  report_json?: { message?: string };
  status?: string;
}

function reportTextFromDone(data: AgentTurnAnswer): string {
  if (typeof data.reportText === 'string' && data.reportText.trim()) {
    return data.reportText.trim();
  }
  const reportJson = data.reportJson ?? data.report_json;
  if (typeof reportJson?.message === 'string' && reportJson.message.trim()) {
    return reportJson.message.trim();
  }
  return '';
}

function parseAgentAnswer(answer: unknown): { text: string; status: MessageStatus } {
  let parsed: AgentTurnAnswer | null = null;
  if (answer && typeof answer === 'object') {
    parsed = answer as AgentTurnAnswer;
  } else if (typeof answer === 'string' && answer.trim()) {
    try {
      parsed = JSON.parse(answer) as AgentTurnAnswer;
    } catch {
      return { text: '', status: 'success' };
    }
  }
  if (!parsed) {
    return { text: '', status: 'success' };
  }
  const ok = !parsed.status || parsed.status === 'ok';
  return {
    text: reportTextFromDone(parsed),
    status: ok ? 'success' : 'error',
  };
}

export function mapConversationSessionToChat(item: ConversationSessionItem): ChatSession {
  const updatedAt = Date.parse(item.updated_at) || Date.now();
  const turns = item.turns ?? [];
  const messages: ChatMessage[] = [];

  for (const turn of turns) {
    const timestamp = Date.parse(turn.created_at) || updatedAt;
    const bizPayload = {
      role: ERole.BUSINESS_ANALYSIS,
      sessionId: item.session_key,
      turnId: turn.turn_key,
      chatRecordId: turn.turn_key,
    };

    messages.push({
      id: `${turn.turn_key}-user`,
      role: 'user',
      type: 'business-analysis',
      bizPayload,
      content: { text: turn.question },
      status: 'success',
      timestamp,
    });
    const answer = parseAgentAnswer(turn.answer);
    messages.push({
      id: `${turn.turn_key}-assistant`,
      role: 'assistant',
      type: 'business-analysis',
      bizPayload,
      content: { text: answer.text },
      status: answer.status,
      timestamp: timestamp + 1,
    });
  }

  return {
    id: item.session_key,
    title: mindMentionDisplayText(turns[0]?.question ?? ''),
    createdAt: Date.parse(turns[0]?.created_at ?? '') || updatedAt,
    updatedAt,
    messages,
  };
}
